import React, { useState, useEffect } from 'react';
import {
  Button,
  Select,
  TextInput,
  Field,
  Fieldset,
  FieldBody,
  Checkbox,
  CheckIcon,
  Alert,
  FieldLabel,
} from '@emorg-prd/react-standard';
import '../locationDetails/index.css';
import PrimaryUseType from '../../../../api/PrimaryUseType';
import OperationStatus from '../../../../api/OperationStatus';
import StoreBrand from '../../../../api/StoreBrand';
import FuelBrand from '../../../../api/FuelBrand';
import StewardshipType from '../../../../api/StewardshipType';
import CostObjectType from '../../../../api/CostObjectType';
import SourceSystem from '../../../../api/SourceSystem';
import SourceSystemIdType from '../../../../api/SourceSystemIdType';
import ProgressTabNavigator from '../ProgressTabNavigator';
import { SourceSystemValidationService as SourceSystemValidation } from '../../../../services/sourceSystemValidationService';

function LocationDetails(props) {
  let {
    primaryUseType,
    affiliateOwnershipPercentage,
    jVOwnershipPercentage,
    isJointVenture,
    locationOperationStatus,
    storeBrand,
    fuelBrand,
    stewardshipCostObjectList,
    sourceSystemLinkList,
    onChange,
    handlePageError,
    onNavigateForward,
    onNavigateBackward,
    onSetProgressTabComplete,
    showLoadingSpinner,
    sourceSystemTypeList,
    sourceSystemList,
    setSourceSystemTypeList,
    setSourceSystemList,
    country,
  } = props;

  const [operationStatusDropdown, setOperationStatusDropdown] = useState([]);
  const [storeBrandDropdown, setStoreBrandDropdown] = useState([]);
  const [fuelBrandDropdown, setFuelBrandDropdown] = useState([]);
  const [stewardshipTypeDropdown, setStewardshipTypeDropdown] = useState([]);
  const [costObjectTypeDropdown, setCostObjectTypeDropdown] = useState([]);
  const [sourceSystemDropdown, setSourceSystemDropdown] = useState([]);
  const [sourceSystemIdTypeDropdown, setSourceSystemIdTypeDropdown] = useState([]);
  const [primaryUseTypeOptionGroups, setprimaryUseTypeOptionGroups] = useState([]);
  const [primaryUseTypeOptions, setprimaryUseTypeOptions] = useState([]);
  const retailParentId = 8;

  useEffect(() => {
    window.scrollTo(0, 0);
    showLoadingSpinner(true);
    PrimaryUseType.getAll().then((res) => {
      res.sort((a, b) => {
        return a.primaryUseTypeName.localeCompare(b.primaryUseTypeName);
      });
      primaryUseTypeDataFilter(res);
    }).catch((error) => {
      handlePageError(error.message);
    });
    OperationStatus.getAll().then((res) => {
      res.sort((a, b) => a.displayOrder - b.displayOrder);
      setOperationStatusDropdown(res);
    }).catch((error) => {
      handlePageError(error.message);
    });
    StoreBrand.getAll().then((res) => {
      res.sort((a, b) => {
        return a.storeBrandName.localeCompare(b.storeBrandName);
      });
      setStoreBrandDropdown(res);
    }).catch((error) => {
      handlePageError(error.message);
    });
    FuelBrand.getAll().then((res) => {
      res.sort((a, b) => {
        return a.fuelBrandName.localeCompare(b.fuelBrandName);
      });
      setFuelBrandDropdown(res);
    }).catch((error) => {
      handlePageError(error.message);
    });
    StewardshipType.getAll().then((res) => {
      res.sort((a, b) => {
        return a.stewardshipTypeName.localeCompare(b.stewardshipTypeName);
      });
      setStewardshipTypeDropdown(res);
    }).catch((error) => {
      handlePageError(error.message);
    });
    CostObjectType.getAll().then((res) => {
      res.sort((a, b) => {
        return a.costObjectTypeName.localeCompare(b.costObjectTypeName);
      });
      setCostObjectTypeDropdown(res);
    }).catch((error) => {
      handlePageError(error.message);
    });
    SourceSystem.getLocationSourceSystems().then((res) => {
      res.sort((a, b) => {
        return a.sourceSystemName.localeCompare(b.sourceSystemName);
      });
      setSourceSystemDropdown(res);
      setSourceSystemList(res);
    }).catch((error) => {
      handlePageError(error.message);
    });
    SourceSystemIdType.getAll().then((res) => {
      res.sort((a, b) => {
        return a.sourceSystemIdTypeName.localeCompare(b.sourceSystemIdTypeName);
      });
      setSourceSystemIdTypeDropdown(res);
      setSourceSystemTypeList(res);
      showLoadingSpinner(false);
    }).catch((error) => {
      handlePageError(error.message);
    });

    onSetProgressTabComplete();
  }, []);

  const renderOperationStatusDropdown = (locationOperationStatus) => (
    <option
      id={locationOperationStatus.operationStatusId}
      key={locationOperationStatus.operationStatusId}
      value={locationOperationStatus.operationStatusName}
      hidden={!locationOperationStatus.isActive}
    >
      {locationOperationStatus.operationStatusName}
    </option>
  );

  const renderStoreBrandDropdown = (storeBrand) => (
    <option
      id={storeBrand.storeBrandId}
      key={storeBrand.storeBrandId}
      value={storeBrand.storeBrandName}
    >
      {storeBrand.storeBrandName}
    </option>
  );

  const renderFuelBrandDropdown = (fuelBrand) => (
    <option
      id={fuelBrand.fuelBrandId}
      key={fuelBrand.fuelBrandId}
      value={fuelBrand.fuelBrandName}
    >
      {fuelBrand.fuelBrandName}
    </option>
  );

  const renderStewardshipTypeDropdown = (stewardshipType) => (
    <option
      id={stewardshipType.stewardshipTypeId}
      key={stewardshipType.stewardshipTypeId}
      value={stewardshipType.stewardshipTypeName}
    >
      {stewardshipType.stewardshipTypeName}
    </option>
  );

  const renderCostObjectTypeDropdown = (costObjectType) => (
    <option
      id={costObjectType.costObjectTypeId}
      key={costObjectType.costObjectTypeId}
      value={costObjectType.costObjectTypeName}
    >
      {costObjectType.costObjectTypeName}
    </option>
  );

  const renderSourceSystemDropdown = (system) => {
    return (
      <option
        id={system.sourceSystemId}
        key={system.sourceSystemId}
        value={system.sourceSystemName}
        hidden={!system.sourceSystemIsActive}
      >
        {system.sourceSystemName}
      </option>
    );
  };

  const renderSourceSystemTypeDropdown = (type) => {
    return (
      <option
        id={type.sourceSystemIdTypeId}
        key={type.sourceSystemIdTypeId}
        value={type.sourceSystemIdTypeName}
        hidden={!type.sourceSystemIdTypeIsActive}
      >
        {type.sourceSystemIdTypeName}
      </option>
    );
  };

  const handleCostObjectChange = (input, index, event) => {
    let stewardshipCostObjectListCopy = [...stewardshipCostObjectList];
    let stewardshipCostObject = stewardshipCostObjectListCopy[parseInt(index)];
    switch (input) {
      case 'stewardshipType':
        stewardshipCostObject.stewardshipTypeName = event.target.value;
        stewardshipCostObject.stewardshipTypeId =
          event.target.options[event.target.selectedIndex].id;
        break;
      case 'costObjectTypeName':
        stewardshipCostObject.costObjectTypeName = event.target.value;
        stewardshipCostObject.costObjectTypeId =
          event.target.options[event.target.selectedIndex].id;
        break;
      case 'costObject':
        stewardshipCostObject.costObject = event.target.value;
        break;
      default:
        alert('error');
    }
    onChange('stewardshipCostObjectList', stewardshipCostObjectListCopy);
  };

  const addCostObjectField = () => {
    let values = [...stewardshipCostObjectList];
    values.push({
      stewardshipTypeId: '',
      stewardshipTypeName: '',
      costObjectTypeId: '',
      costObjectTypeName: '',
      costObject: '',
    });
    onChange('stewardshipCostObjectList', values);
  };

  const removeCostObjectField = (index) => {
    let values = [...stewardshipCostObjectList];
    values.splice(index, 1);
    onChange('stewardshipCostObjectList', values);
  };

  const getAvailableSourceSystemTypes = (currentIndex, sourceSystemId) => {
  const selectedTypeIds = sourceSystemLinkList
    .filter(
      (item, index) =>
        index !== currentIndex &&
        String(item.sourceSystemId) === String(sourceSystemId)
    )
    .map(item => String(item.sourceSystemIdTypeId))
    .filter(Boolean);

  return sourceSystemIdTypeDropdown.filter(
    type =>
      String(type.sourceSystemId) === String(sourceSystemId) &&
      (
        !selectedTypeIds.includes(String(type.sourceSystemIdTypeId)) ||
        String(type.sourceSystemIdTypeId) ===
          String(sourceSystemLinkList[currentIndex]?.sourceSystemIdTypeId)
      )
  );
};

  const handleSourceSystemChange = (input, index, event) => {
    let sourceSystemLinkListCopy = [...sourceSystemLinkList];
    let sourceLinkObject = sourceSystemLinkListCopy[parseInt(index)];
    switch (input) {
      case 'sourceSystem':
        sourceLinkObject.sourceSystemName = event.target.value;
        sourceLinkObject.sourceSystemId = event.target.options[event.target.selectedIndex].id;
        sourceLinkObject.sourceSystemIdTypeName = '';
        sourceLinkObject.sourceSystemIdTypeId = '';
        sourceLinkObject.sourceSystemReferenceId = '';
        break;
      case 'sourceSystemIdType':
        sourceLinkObject.sourceSystemIdTypeName = event.target.value;
        sourceLinkObject.sourceSystemIdTypeId = event.target.options[event.target.selectedIndex].id;
        sourceLinkObject.isSourceSystemValid = SourceSystemValidation.isNoValidationSourceSystem(sourceLinkObject);
        break;
      case 'sourceSystemReferenceId':
        if (
          SourceSystemValidation.isOriginalSourceSystem(event.target.value, sourceLinkObject)
          || SourceSystemValidation.isNoValidationSourceSystem(sourceLinkObject)
        ) {
          sourceLinkObject.isSourceSystemValid = true;
        }
        else {
          sourceLinkObject.isSourceSystemValid = false;
        }
        sourceLinkObject.sourceSystemReferenceId = event.target.value;
        break;
      default:
        alert('error');
    }
    onChange('sourceSystemLinkList', sourceSystemLinkListCopy);
  };

  const addSourceSystemField = () => {
    let values = [...sourceSystemLinkList];
    values.push({
      sourceSystemId: '',
      sourceSystemName: '',
      sourceSystemIdTypeId: '',
      sourceSystemIdTypeName: '',
      sourceSystemReferenceId: '',
      sourceSystemIsActive: true,
      sourceSystemIdTypeIsActive: true,
      isSourceSystemValid: false,
      isLoading: false,
      validationErrorMessage: ''
    });
    onChange('sourceSystemLinkList', values);
  };

  const removeSourceSystemField = (index) => {
    let values = [...sourceSystemLinkList];
    values.splice(index, 1);
    onChange('sourceSystemLinkList', values);
  };

  async function validateSourceSystemReferenceId(index, countryId) {
    let sourceSystemLinkListCopy = [...sourceSystemLinkList];
    let sourceSystemLink = sourceSystemLinkListCopy[parseInt(index)];

    sourceSystemLink.validationErrorMessage = '';
    sourceSystemLink.isLoading = true;
    onChange('sourceSystemLinkList', sourceSystemLinkListCopy);

    sourceSystemLink = await SourceSystemValidation.validateLocationSourceSystem(sourceSystemLink, countryId);

    onChange('sourceSystemLinkList', sourceSystemLinkListCopy);
  }

  const handleJVChange = (checked) => {
    if (checked) {
      onChange('jVOwnershipPercentage', jVOwnershipPercentage);
      onChange('affiliateOwnershipPercentage', 0);
    } else {
      affiliateOwnershipPercentage = 100;
      onChange('affiliateOwnershipPercentage', affiliateOwnershipPercentage);
      onChange('jVOwnershipPercentage', 0);
    }
    onChange('isJointVenture', checked);
  };
  const checkJointVentureOwnershipPercent = (isJointVenture, value) => {
    let regx = /^\d{0,3}(\.)?\d{0,2}$/;
    if (value === '' || regx.test(value)) {
      if (parseInt(value) > 100) {
        alert('Joint Ownership must be equal or less than 100% ');
      } else {
        onChange(isJointVenture, value);
      }
    }
  };
  const primaryUseTypeDataFilter = (primaryUseTypeData) => {
    let optionGroups = primaryUseTypeData.filter((primaryUse) => {
      if (primaryUse.isAssignable.trim().toLowerCase() === 's') {
        return primaryUse;
      }
      return null;
    });
    let primaryUseTypeOptions = primaryUseTypeData.filter((primaryUse) => {
      if (primaryUse.isAssignable.trim().toLowerCase() === 'l') { // L not I
        return primaryUse;
      }
      return null;
    });
    setprimaryUseTypeOptionGroups(optionGroups);
    setprimaryUseTypeOptions(primaryUseTypeOptions);
  };
  const getPrimaryUseTypeParent = (primaryUseTypeId) => {
    let filteredPrimaryUse = primaryUseTypeOptions.find((primaryUse) => {
      if (primaryUse.primaryUseTypeId.toString() === primaryUseTypeId) {
        return primaryUse;
      }
      return null;
    });
    return filteredPrimaryUse;
  };

  const handlePrimaryUseTypeChange = (e) => {
    const currentParent = getPrimaryUseTypeParent(
      e.target.options[e.target.selectedIndex].id
    );
    onChange('primaryUseType',
      {
        id: `${e.target.options[e.target.selectedIndex].id}`,
        name: e.target.value,
        parentId: currentParent ? currentParent.primaryUseTypeParentId : null,
        isActive: true
      }
    );
    if (!currentParent || currentParent.primaryUseTypeParentId !== retailParentId) {
      onChange('storeBrand', { id: null, name: '' });
      onChange('fuelBrand', { id: null, name: '' });
    }
  }

  return (
    <div className='page'>
      <Fieldset>
        <div className='detail-row'>
          <Select
            style={{ paddingRight: '150px' }}
            selectProps={{
              className: 'details-select',
              style: {backgroundColor: (
                (primaryUseTypeOptionGroups.filter(x => x.isActive == true).find(x => x.primaryUseTypeId === primaryUseType.parentId)
                && primaryUseType.isActive)
                || primaryUseType.name === ''
                || !primaryUseTypeOptionGroups.length
              ) ? 'white' : 'lightgray'}
            }}
            label='Location Primary Use *'
            value={primaryUseType.name}
            error={primaryUseType.id === null}
            onChange={(e) => handlePrimaryUseTypeChange(e)}
          >
            <option value='' style={{ backgroundColor: 'white'}}>Select</option>
            {primaryUseTypeOptionGroups.map((optionGroup) => {
              return (
                <optgroup
                  key={optionGroup.primaryUseTypeId}
                  label={optionGroup.primaryUseTypeName}
                  hidden={!optionGroup.isActive}
                >
                  {primaryUseTypeOptions.map((primaryUseTypeOption) => {
                    if (
                      primaryUseTypeOption.primaryUseTypeParentId ===
                      optionGroup.primaryUseTypeId
                    ) {
                      return (
                        <option
                          key={primaryUseTypeOption.primaryUseTypeId}
                          id={primaryUseTypeOption.primaryUseTypeId}
                          value={primaryUseTypeOption.primaryUseTypeName}
                          hidden={!primaryUseTypeOption.isActive}
                        >
                          {primaryUseTypeOption.primaryUseTypeName}
                        </option>
                      );
                    }
                    return null;
                  })}
                </optgroup>
              );
            })}
          </Select>

          {isJointVenture ? (
            <div>
              <h6>Joint Ownership</h6>
              <div style={{ display: 'flex', flexDirection: 'row', height: '55px' }}>
                <TextInput
                  style={{ width: '80px' }}
                  value={jVOwnershipPercentage}
                  onChange={(e) =>
                    checkJointVentureOwnershipPercent(
                      'jVOwnershipPercentage',
                      e.target.value
                    )
                  }
                />
                <p style={{ paddingTop: '5px', paddingLeft: '5px', fontSize: 'large' }}>
                  %
                </p>
              </div>
            </div>
          ) : (
            <div></div>
          )}

          <div>
            <Checkbox
              style={{
                paddingTop: '30px',
                paddingLeft: '5px',
                border: 0,
                background: 'transparent',
              }}
              id='joint-venture'
              value={1}
              label='Joint Venture?'
              checked={isJointVenture}
              onChange={(checked) => handleJVChange(checked)}
            />
          </div>
        </div>

        <div className='detail-row'>
          <div class="em-c-field ">
            <label class="em-c-field__label">Operation Status *</label>
            <div class="em-c-field__body">
              <Select
                style={{
                  backgroundColor: locationOperationStatus.isActive ? 'white' : 'lightgray'
                }}
                selectProps={{
                  className: 'details-select'
                }}
                value={locationOperationStatus.name}
                error={locationOperationStatus.id === null}
                onChange={(e) => {
                  onChange('locationOperationStatus', {
                    id: `${e.target.options[e.target.selectedIndex].id}`,
                    name: e.target.value,
                    isActive: true
                  });
                }}
              >
                <option value=''>Select</option>
                {operationStatusDropdown.map(renderOperationStatusDropdown)}
              </Select>
            </div>
          </div>
        </div>

        <div>
          {primaryUseType.parentId === retailParentId ? (
            <div className='detail-row'>
              <Select
                style={{ paddingRight: '150px' }}
                selectProps={{
                  className: 'details-select',
                }}
                label='Store Brand *'
                value={storeBrand.name}
                error={!storeBrand.id}
                onChange={(e) => {
                  onChange('storeBrand', {
                    id: `${e.target.options[e.target.selectedIndex].id}`,
                    name: e.target.value,
                  });
                }}
              >
                <option value=''>Select</option>
                {storeBrandDropdown.map(renderStoreBrandDropdown)}
              </Select>
              <Select
                selectProps={{
                  className: 'details-select',
                }}
                label='Fuel Brand *'
                value={fuelBrand.name}
                error={!fuelBrand.id}
                onChange={(e) => {
                  onChange('fuelBrand', {
                    id: `${e.target.options[e.target.selectedIndex].id}`,
                    name: e.target.value,
                  });
                }}
              >
                <option value=''>Select</option>
                {fuelBrandDropdown.map(renderFuelBrandDropdown)}
              </Select>
            </div>
          ) : (
            ''
          )}
        </div>
      </Fieldset>

      <div>
        <Fieldset>
          {stewardshipCostObjectList.map((stewardshipCostObject, index) => (
            <Field key={`${stewardshipCostObject}~${index}`}>
              <FieldLabel></FieldLabel>
              <FieldBody>
                <div className='detail-select-row'>
                  <Select
                    selectProps={{
                      className: 'cost-object-select',
                    }}
                    label='Stewardship Type'
                    value={stewardshipCostObject.stewardshipTypeName}
                    error={!stewardshipCostObject.stewardshipTypeId}
                    onChange={(e) => handleCostObjectChange('stewardshipType', index, e)}
                  >
                    <option value=''>Select</option>
                    {stewardshipTypeDropdown.map(renderStewardshipTypeDropdown)}
                  </Select>

                  <Select
                    selectProps={{
                      className: 'cost-object-select',
                    }}
                    style={{ paddingLeft: '15px' }}
                    label='Cost Object Type'
                    value={stewardshipCostObject.costObjectTypeName}
                    error={!stewardshipCostObject.costObjectTypeId}
                    onChange={(e) =>
                      handleCostObjectChange('costObjectTypeName', index, e)
                    }
                  >
                    <option value=''>Select</option>
                    {costObjectTypeDropdown.map(renderCostObjectTypeDropdown)}
                  </Select>

                  <TextInput
                    style={{ width: '250px', paddingLeft: '15px' }}
                    label='Cost Object'
                    value={stewardshipCostObject.costObject}
                    error={!stewardshipCostObject.costObject}
                    onChange={(e) => handleCostObjectChange('costObject', index, e)}
                  />

                  <Button
                    style={{ paddingTop: '42px', paddingLeft: '30px' }}
                    className='small-margin'
                    variant='tertiary'
                    size='small'
                    onClick={() => removeCostObjectField(index)}
                  >
                    × Remove Stewardship Cost Object
                  </Button>
                </div>
              </FieldBody>
            </Field>
          ))}

          <Button
            className='small-margin'
            variant='tertiary'
            size='small'
            style={{ paddingTop: '0px', marginTop: '0px' }}
            onClick={addCostObjectField}
          >
            + Add Stewardship Cost Object
          </Button>
          {/*<pre>{JSON.stringify(connexionCodeErrorMessage, null, 2)}</pre>*/}
        </Fieldset>
      </div>

      <div>
        <Fieldset>
          {sourceSystemLinkList.map((sourceSystemLink, index) => (
            <Field key={`${sourceSystemLink}~${index}`}>
              <FieldLabel></FieldLabel>
              <FieldBody>
                <Alert
                  variant='error'
                  style={{
                    marginBottom: '15px',
                    display:
                    sourceSystemLink.validationErrorMessage != ''
                      ? 'flex' : 'none',
                  }}
                >
                  {sourceSystemLink.validationErrorMessage}
                </Alert>

                <div className='detail-select-row'>
                  <Select
                    selectProps={{
                      className: 'source-system-select',
                    }}
                    label='Source System'
                    disabled={!sourceSystemLink.sourceSystemIsActive || !sourceSystemLink.sourceSystemIdTypeIsActive}
                    value={sourceSystemLink.sourceSystemName}
                    error={!sourceSystemLink.sourceSystemId}
                    onChange={(e) => handleSourceSystemChange('sourceSystem', index, e)}
                  >
                    <option value=''>Select</option>
                    {sourceSystemDropdown.map(renderSourceSystemDropdown)}
                  </Select>

                  <Select
                    style={{ paddingLeft: '15px' }}
                    selectProps={{
                      className: 'source-system-select',
                    }}
                    label='Source System Type'
                    disabled={!sourceSystemLink.sourceSystemIsActive || !sourceSystemLink.sourceSystemIdTypeIsActive}
                    value={sourceSystemLink.sourceSystemIdTypeName}
                    error={!sourceSystemLink.sourceSystemIdTypeId}
                    onChange={(e) =>
                      handleSourceSystemChange('sourceSystemIdType', index, e)
                    }
                  >
                    <option value=''>Select</option>
                    {/* {sourceSystemIdTypeDropdown
                      .filter(
                        (type) => type.sourceSystemId == sourceSystemLink.sourceSystemId
                      )
                      .map(renderSourceSystemTypeDropdown)} */}
                      {getAvailableSourceSystemTypes(
                          index,
                        sourceSystemLink.sourceSystemId
                      ).map(renderSourceSystemTypeDropdown)}
                      
                  </Select>

                  <form className='-em-c-search-form'>
                    <div className='em-c-search__body'>
                      <TextInput
                        style={{ width: '250px', paddingLeft: '15px' }}
                        inputProps={{ className: 'reference-id' }}
                        label='Source System Reference ID'
                        disabled={!sourceSystemLink.sourceSystemIsActive || !sourceSystemLink.sourceSystemIdTypeIsActive}
                        value={sourceSystemLink.sourceSystemReferenceId}
                        error={
                          !sourceSystemLink.sourceSystemReferenceId ||
                          !sourceSystemLink.isSourceSystemValid
                        }
                        onChange={(e) =>
                          handleSourceSystemChange('sourceSystemReferenceId', index, e)
                        }
                      />

                      <Button
                        style={{
                          display:
                            sourceSystemLink.sourceSystemIdTypeName &&
                            sourceSystemLink.sourceSystemReferenceId &&
                            !SourceSystemValidation.isNoValidationSourceSystem(sourceSystemLink) &&
                            !sourceSystemLink.isLoading &&
                            sourceSystemLink.sourceSystemIsActive
                              ? 'block' : 'none'
                        }}
                        className={
                          !sourceSystemLink.isSourceSystemValid
                            ? 'small-margin validation-button red-outline'
                            : 'small-margin validation-button grey-outline'
                        }
                        variant='secondary'
                        size='medium'
                        error={
                          sourceSystemLink.sourceSystemIdTypeName &&
                          !sourceSystemLink.isSourceSystemValid
                        }
                        onClick={(e) => {
                          if (
                            sourceSystemLink.sourceSystemIdTypeId &&
                            sourceSystemLink.sourceSystemReferenceId &&
                            sourceSystemLink.sourceSystemName
                          ) {
                            validateSourceSystemReferenceId(index, country.id)
                          }}
                        }
                      >
                        {sourceSystemLink.isSourceSystemValid ? '' : 'Validate'}
                        <CheckIcon
                          style={{
                            display:
                              sourceSystemLink.isSourceSystemValid ? 'block' : 'none'
                          }}
                        />
                      </Button>
                      <Button
                        style={{
                          display:
                            sourceSystemLink.sourceSystemIdTypeName &&
                            sourceSystemLink.isLoading
                              ? 'block' : 'none',
                        }}
                        className='small-margin validation-button'
                        loading
                        size='medium'
                      >
                        Loading
                      </Button>
                    </div>
                  </form>

                  <Button
                    style={{ paddingTop: '42px', paddingLeft: '30px' }}
                    className='small-margin'
                    variant='tertiary'
                    size='small'
                    onClick={() => removeSourceSystemField(index)}
                  >
                    × Remove Location Source Link
                  </Button>
                </div>
              </FieldBody>
            </Field>
          ))}

          <Button
            className='small-margin'
            variant='tertiary'
            size='small'
            style={{ paddingTop: '0px', marginTop: '0px' }}
            onClick={addSourceSystemField}
          >
            + Add Location Source Link
          </Button>
        </Fieldset>
      </div>

      <ProgressTabNavigator
        onNavigateBackward={onNavigateBackward}
        onNavigateForward={onNavigateForward}
      > 
      </ProgressTabNavigator>
    </div>
  );
}

export default LocationDetails;
